import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import { createI18n, I18nProvider, feedback } from '@bino/utils/i18next';
import { Pending } from '@bino/utils/components/pending';
import { Feedback } from './components/Feedback';
import { FeedbackFooter } from './components/FeedbackFooter';

const i18n = createI18n(feedback);

export const renderApp = (id: string, turnstileSiteKey: string) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <Suspense fallback={<Pending />}>
            <I18nProvider i18n={i18n}>
                <Feedback turnstileSiteKey={turnstileSiteKey} />
            </I18nProvider>
        </Suspense>,
    );
};

export const renderInFooter = (id: string, turnstileSiteKey: string) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <Suspense fallback={<Pending />}>
            <I18nProvider i18n={i18n}>
                <FeedbackFooter turnstileSiteKey={turnstileSiteKey} />
            </I18nProvider>
        </Suspense>,
    );
};
